const requestImageFile = require.context(
    "../assets/images",
    true
);

export default requestImageFile